import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  token: "",
  isLogin: false,
  name: "",
  email: "",
  password: "",
  cellNumber: "",
  image: "",
  companyName: "",
  companyDetailId: "",
  companyTimezone: "",
  userType: "",
  menu: "",
  roleName: "",
  roleId: "",
  versionMatch: "",
  refreshToken: "",
  fcmToken: "",
  menu:[]
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setLoginToken: (state, action) => {
      state.token = action.payload.accessToken;
      state.isLogin = true;
    },
    setToken: (state, action) => {
      state.token = action.payload?.accessToken;
    },
    setEmail: (state, action) => {
      state.email = action.payload;
    },
    setUser: (state, action) => {
      state.name = action.payload?.name;
      state.email = action.payload?.email;
      state.password = action.payload?.password;
      state.cellNumber = action.payload?.cellNumber;
      state.image = action.payload?.image;
      state.companyName = action.payload?.companyName;
      state.companyDetailId = action.payload?.companyDetailId;
      state.companyTimezone = action.payload?.companyTimezone;
      state.userType = action.payload?.userType;
      state.menu = action.payload?.menu;
      state.roleName = action.payload?.roleName;
      state.roleId = action.payload?.roleId;
      state.versionMatch = action.payload?.versionMatch;
      state.refreshToken = action.payload?.refreshToken;
      state.menu = action.payload?.menu;
    },
    setPassword: (state, action) => {
      state.password = action.payload.password;
    },
    logout: (state) => {
      state.accessToken = "";
      state.isLogin = false;
      state.user = null;
      state.menu=[]
    },
    setFcmToken: (state, action) => {
      state.fcmToken = action.payload;
    },
  },
});

export const {
  setLoginToken,
  setToken,
  logout,
  setUser,
  setPassword,
  setEmail,
  setFcmToken,
} = authSlice.actions;
export default authSlice.reducer;
